export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

import { formatDateSafely } from './dateUtils'

export const formatDate = (dateString: string): string => {
  return formatDateSafely(dateString, { format: 'short' })
}

export const getStudentFullName = (student: { first_name: string; last_name: string }): string => {
  return `${student.first_name} ${student.last_name}`.trim()
}
